module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimInfoForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "claimant_date_of_onset",
      "label": _vm.getClaimantDetail('diseaseOrAccident') === 'disease' ? 'Claimant Date of Onset Symptoms' : 'Claimant Date of Injury / Accident'
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimant_date_of_onset.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimant_date_of_onset",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "claimant_date_of_onset"
    },
    model: {
      value: (_vm.onsetOfSymptoms),
      callback: function($$v) {
        _vm.onsetOfSymptoms = $$v
      },
      expression: "onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_date_of_onset') || !_vm.onsetRules
    }
  }, [_vm._v("\n                        The claimant's onset of symptoms is required, must be in the format DD/MM/YYYY\n                        and must be after the Claimant's date of birth " + _vm._s(_vm.dateOfBirth) + "\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimants_assumed_dod_type",
      "label": "Claimant's Assumed Date of Death"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assumedLifeExpectancyMethod),
      expression: "assumedLifeExpectancyMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimants_assumed_dod_type",
      "id": "claimants_assumed_dod_type",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assumedLifeExpectancyMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_years_and_months_left"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_age_at_death"
    }
  }, [_vm._v("Enter Age at Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_percentage_of_life"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_reduction_in_life"
    }
  }, [_vm._v("% Reduction in Normal Life Expectancy")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimants_assumed_dod_type')
    }
  }, [_vm._v("\n                        The claimant's assumed Date of Death is required\n                    ")])], 1), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_age_at_death') ? _c('control', {
    attrs: {
      "for": "claimants_age_at_assumed_death",
      "label": "Claimant's Age at Assumed Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death',
      "name": "claimants_age_at_assumed_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_years_and_months_left') ? _c('control', {
    attrs: {
      "for": "claimants_assumed_years_left",
      "label": "Enter Years/Months From Today"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.yearsLeft),
      expression: "yearsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.yearsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.monthsLeft),
      expression: "monthsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.monthsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                                    " + _vm._s(month - 1) + " month(s)\n                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_percentage_of_life') ? _c('control', {
    attrs: {
      "label": "Percentage of Normal Life Expectancy",
      "for": "percentage_of_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_percentage_of_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageOfNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n                        The percentage of normal life expectancy must be number between 1 and 100\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_reduction_in_life') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "for": "percentage_reduction_in_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_reduction_in_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageReductionInNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n                        The percentage reduction in normal life expectancy must be number between 1 and 100\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimants_assumed_date_of_death",
      "label": "Claimant's Assumed Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimants_assumed_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimants_assumed_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_date'
    },
    on: {
      "input": _vm.updateAssumedLifeExpectancy
    },
    model: {
      value: (_vm.dateOfDeath),
      callback: function($$v) {
        _vm.dateOfDeath = $$v
      },
      expression: "dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimants_assumed_date_of_death')
    }
  }, [_vm._v("\n                        The claimant's assumed date of death is required\n                    ")])], 1), _vm._v(" "), _c('life-expectancy', {
    attrs: {
      "label": "Claimant's 'But For' Life Expectancy",
      "person": _vm.claimant,
      "date": _vm.theDate,
      "assumed-settlement": _vm.getClaimantInfoValue('dateOfAssumedSettlement'),
      "type": "deceased",
      "stepValid": _vm.isValid()
    },
    on: {
      "update": _vm.updateLife
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "reduction_in_claimants_life_expectancy",
      "label": "Reduction in Claimant's Life Expectancy",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.claimantReductionInLife),
      expression: "claimantReductionInLife",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "name": "reduction_in_claimants_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.claimantReductionInLife)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReductionInLife = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.claimantReductionInLifeRules
    }
  }, [_vm._v("\n                        Reduction in Claimant's Life Expectancy must be greater than 0\n                    ")])], 1), _vm._v(" "), (_vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death') ? _c('control', {
    attrs: {
      "for": "claimants_age_at_assumed_death",
      "label": "Claimant's Age at Assumed Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death',
      "name": "claimants_age_at_assumed_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "period_between_onset_of_symptoms_and_assumed_dod",
      "label": "Period Between Onset of Symptoms and Assumed DOD",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.periodBetweenOnsetAndAssumedDod),
      expression: "periodBetweenOnsetAndAssumedDod",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "name": "period_between_onset_of_symptoms_and_assumed_dod",
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodBetweenOnsetAndAssumedDod)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.periodBetweenOnsetAndAssumedDod = _vm._n($event.target.value)
      }, _vm.updateReductionInLife],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_onset_of_symptoms",
      "label": "Claimant's Age at Onset of Symptoms",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtOnsetOfSymptoms),
      expression: "ageAtOnsetOfSymptoms",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "name": "age_at_onset_of_symptoms",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtOnsetOfSymptoms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtOnsetOfSymptoms = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c214dc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/lost-years-claims/steps/ClaimInfo.vue
// module id = 1734
// module chunks = 0